import { isEmpty } from 'lodash'

export const setPasscode = passcode => {
  localStorage.setItem('passcode', passcode)
}

export const removePasscode = passcode => {
  localStorage.removeItem('passcode')
}

export const getPasscode = () => {
  const passcode = localStorage.getItem('passcode')
  return isEmpty(passcode) ? undefined : passcode
}



// WEBPACK FOOTER //
// ./src/modules/passcode/storage.js